<template>
  <div class="tag-anchor" :style="styles" :id="$attrs._id">
    <div 
      class="tag-line"
      :style="lineStyle"
    ></div>
    <div 
      v-if="tailPosition !== 'none'"
      class="tag-dot"
    ></div>
    <div 
      class="tag-action"
      :class="[
        `tag-action--${type}`
      ]"
      ref="el"
      :style="labelStyle"
    >
      <fa :icon="icon"/>
    </div>
  </div>
</template>
<script>
export default {
  props: ['pos', 'label', 'type', 'tail-height', 'tail-position', 'icon'],

  computed: {
    styles () {
      return {
        left: `${(this.pos.x / 20)}em`,
        top: `${(this.pos.y / 20)}em`,
      }
    },

    labelStyle () {
      switch (this.tailPosition) {
        case 'none':
          return ``
        
        case 'bottom-left':
          return `
            bottom: 0;
            transform: translate(-1em, -${this.tailHeight * 1.33}em);
          `

        case 'bottom-center':
          return `
            bottom: 0;
            left: 50%;
            transform: translate(-50%, -${this.tailHeight * 1.33}em);
          `

        case 'bottom-right':
          return `
            bottom: 0;
            right: 0;
            transform: translate(1em, -${this.tailHeight * 1.33}em);
          `

        case 'top-left':
          return `
            transform: translate(-1em, ${this.tailHeight * 1.33}em);
          `

        case 'top-center':
          return `
            left: 50%;
            transform: translate(-50%, ${this.tailHeight * 1.33}em);
          `

        case 'top-right':
          return `
            right: 0;
            transform: translate(1em, ${this.tailHeight * 1.33}em);
          `

        case 'left-center':
          return `
            left: 0;
            top: .125em;
            transform: translate(${this.tailHeight * 1.33}em, -50%);
          `

        case 'right-center':
          return `
            right: 0;
            top: .125em;
            transform: translate(-${this.tailHeight * 1.33}em, -50%);
          `
      
        default:
          return ''
      }
    },

    lineStyle () {
      switch (this.tailPosition) {
        case 'none':
          return `display: none;`
        
        case 'bottom-left':
          return `
            height: ${this.tailHeight}em;
            transform: translateY(-${this.tailHeight}em);
            z-index: 6;
          `

        case 'bottom-center':
          return `
            height: ${this.tailHeight}em;
            transform: translateY(-${this.tailHeight}em);
            z-index: 6;
          `

        case 'bottom-right':
          return `
            height: ${this.tailHeight}em;
            transform: translateY(-${this.tailHeight}em);
            z-index: 6;
          `

        case 'top-left':
          return `
            bottom: 0;
            height: ${this.tailHeight}em;
            transform: translateY(${this.tailHeight}em);
          `

        case 'top-center':
          return `
            bottom: 0;
            height: ${this.tailHeight}em;
            transform: translateY(${this.tailHeight}em);
          `

        case 'top-right':
          return `
            bottom: 0;
            height: ${this.tailHeight}em;
            transform: translateY(${this.tailHeight}em);
          `

        case 'left-center':
          return `
            height: .25em;
            right: 0;
            top: -.125em;
            width: ${this.tailHeight}em;
            transform: translateX(0);
            z-index: 6;
          `

        case 'right-center':
          return `
            height: .25em;
            left: 0;
            top: -.125em;
            width: ${this.tailHeight}em;
            transform: translateX(-${this.tailHeight}em);
            z-index: 6;
          `
      
        default:
          return ''
      }
    },
  }
}
</script>
<style lang="scss" scoped>
@import "@/styles/_variables.scss";

.tag-anchor {
  color: $action-tag-bg-color;
  font-size: 1em;
  position: absolute;
  pointer-events: none;
  transition: opacity 200ms ease-in-out, box-shadow 200ms ease-in-out;
  z-index: 5;

  &.inactive {
    opacity: .5 !important;
  }
}

.tag-dot {
  background: $white;
  border-radius: 50%;
  bottom: -.25em;
  height: .5em;
  left: -.25em;
  pointer-events: auto;
  position: absolute;
  width: .5em;
}

.tag-line {
  background: $white;
  left: -.125em;
  pointer-events: auto;
  position: absolute;
  width: .25em;
}

.tag-action {
  align-items: center;
  background-color: $action-tag-bg-color;
  border: .35em solid #fff;
  border-radius: $action-tag-border-radius;
  box-shadow: $tag-box-shadow;
  color: $action-tag-font-color;
  display: flex;
  font-family: $touchscreen-font;
  font-size: $action-tag-font-size;
  font-weight: 400;
  height: 6em;
  justify-content: center;
  letter-spacing: .1em;
  line-height: 1.1;
  padding: .5em 1.1em .4em;
  pointer-events: auto;
  position: absolute;
  text-align: center;
  text-transform: uppercase;
  user-select: none;
  width: 6em;

  svg {
    font-size: 3.8em;
  }
}
</style>
